export default function SeoValueSection() {
  return (
    <section className="w-full bg-accent-50/60 px-6 md:px-10 py-16 md:py-24">
      <div className="max-w-7xl mx-auto">
        <div className="mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-800 text-xs font-label tracking-wider">
            Why Pandabuyspreadsheet
          </span>
          <h2 className="mt-5 text-2xl md:text-4xl font-heading text-foreground-900 max-w-2xl leading-tight">
            How <span className="text-accent-600">Pandabuyspreadsheet</span> Is Changing Product Discovery
          </h2>
          <p className="mt-4 text-sm text-foreground-600 max-w-xl leading-relaxed">
            Pandabuyspreadsheet simplifies product discovery by organizing thousands of items into structured, easy-to-navigate collections. Instead of searching manually across scattered sources, users can instantly access curated lists of trending products across multiple categories — from shoes and streetwear to accessories and lifestyle goods. Every pandabuyspreadsheet entry is verified for quality and regularly refreshed to reflect the latest community-driven discoveries.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {[
            { icon: "ri-refresh-line", label: "Updated Daily" },
            { icon: "ri-check-double-line", label: "Curated Lists" },
            { icon: "ri-links-line", label: "Programmatic SEO" },
            { icon: "ri-shield-check-line", label: "Safe Access" },
          ].map((item) => (
            <div key={item.label}>
              <div className="w-10 h-10 rounded-xl bg-accent-100/80 flex items-center justify-center mb-4">
                <i className={`${item.icon} text-accent-600 text-lg`}></i>
              </div>
              <p className="text-sm text-foreground-700">{item.label}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            { value: "100+", label: "Spreadsheets" },
            { value: "14", label: "Categories" },
            { value: "50K+", label: "Products Listed" },
            { value: "<2s", label: "Page Load" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-3xl md:text-4xl font-heading text-accent-600">
                {stat.value}
              </div>
              <div className="mt-1 text-xs text-foreground-500 font-label tracking-wider uppercase">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}